import { Checkbox } from "../../../../../../styles/page";
import { usePosterContext } from "../../../../context/poster-context";
import {
  MainInfoHeaderItem,
  MainInfoHeader,
  MainInfoWrapper,
  MainInfoContentWrapper,
  MainInfoContentItem,
  MainInfoContentItemInput,
  MainInfoSectionWrapper,
  MainInfoSectionItem,
} from "../main-info/styles/main-info.style";

const Info = () => {
  const {
    tournamentType,
    setTournamentType,
    registerLimitLevel,
    setRegisterLimitLevel,
    entry,
    setEntry,
    buyIn,
    setBuyIn,
    startingStack,
    setStartingStack,
    reBuyIn,
    setReBuyIn,
    reBuyInStack,
    setReBuyInStack,
    addOn,
    setAddOn,
    addOnStack,
    setAddOnStack,
    duration,
    setDuration,
    infoSection,
    setInfoSection,
    infoFontSize,
    setInfoFontSize,
  } = usePosterContext();

  const items = [
    {
      key: "tournamentType",
      data: tournamentType,
      setData: setTournamentType,
    },
    {
      key: "registerLimitLevel",
      data: registerLimitLevel,
      setData: setRegisterLimitLevel,
    },
    {
      key: "startDate",
      data: entry,
      setData: setEntry,
    },
    {
      key: "buyIn",
      data: buyIn,
      setData: setBuyIn,
    },
    {
      key: "startingStack",
      data: startingStack,
      setData: setStartingStack,
    },
    {
      key: "reBuyIn",
      data: reBuyIn,
      setData: setReBuyIn,
    },
    {
      key: "reBuyInStack",
      data: reBuyInStack,
      setData: setReBuyInStack,
    },
    {
      key: "addOn",
      data: addOn,
      setData: setAddOn,
    },
    {
      key: "addOnStack",
      data: addOnStack,
      setData: setAddOnStack,
    },
    {
      key: "duration",
      data: duration,
      setData: setDuration,
    },
  ];
  return (
    <MainInfoWrapper>
      <MainInfoSectionWrapper>
        <MainInfoSectionItem>
          <div className="label">섹션명</div>
          <MainInfoContentItemInput
            value={infoSection}
            onChange={(e) => {
              setInfoSection(e.target.value);
            }}
          />
        </MainInfoSectionItem>
        <MainInfoSectionItem>
          <div className="label">폰트 크기</div>
          <img
            src="/image-web/poster/minus.svg"
            alt="minus"
            onClick={() => {
              if (infoFontSize > 1) {
                setInfoFontSize(infoFontSize - 1);
              }
            }}
          />
          <div className="font-size">{infoFontSize}</div>
          <img
            src="/image-web/poster/plus.svg"
            alt="plus"
            onClick={() => setInfoFontSize(infoFontSize + 1)}
          />
        </MainInfoSectionItem>
      </MainInfoSectionWrapper>
      <MainInfoHeader>
        <MainInfoHeaderItem flex={1}>포함여부</MainInfoHeaderItem>
        <MainInfoHeaderItem flex={3}>항목</MainInfoHeaderItem>
        <MainInfoHeaderItem flex={3}>내용 </MainInfoHeaderItem>
      </MainInfoHeader>
      {items.map((item) => (
        <MainInfoContentWrapper key={item.key} style={{ gap: "10px" }}>
          <MainInfoContentItem flex={1}>
            <Checkbox
              checked={item.data.isShow}
              onChange={() => {
                item.setData({
                  ...item.data,
                  isShow: !item.data.isShow,
                });
              }}
            />
          </MainInfoContentItem>
          <MainInfoContentItem flex={3}>
            <MainInfoContentItemInput
              disabled={!item.data.isShow}
              value={item.data.label}
              onChange={(e) => {
                item.setData({
                  ...item.data,
                  label: e.target.value,
                });
              }}
            />
          </MainInfoContentItem>
          <MainInfoContentItem flex={3}>
            <MainInfoContentItemInput
              disabled={!item.data.isShow}
              value={item.data.value}
              onChange={(e) => {
                item.setData({
                  ...item.data,
                  value: e.target.value,
                });
              }}
            />
          </MainInfoContentItem>
        </MainInfoContentWrapper>
      ))}
    </MainInfoWrapper>
  );
};

export default Info;
